<template>
  <!-- 消耗品発送履歴 -->
  <div id="AppDispoDeliveryHistorySearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">消耗品発送履歴</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="検索期間" labelPosition="on-border">
              <b-datepicker
                v-model="startDate"
                name="startDate"
                type="month"
                placeholder="検索開始年月"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              ></b-datepicker>
              <b-datepicker
                v-model="endDate"
                name="endDate"
                type="month"
                placeholder="検索終了年月"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              ></b-datepicker>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="登録者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="登録者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="登録者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="登録者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="品目コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productCode"
                name="productCode"
                data-vv-as="品目コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="品目名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productName"
                name="productName"
                data-vv-as="品目名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientCode"
                name="patientCode"
                data-vv-as="患者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientName"
                name="patientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="定期/非定期" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.deliveryKindFlagGroup"
                native-value="1"
              >定期</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.deliveryKindFlagGroup"
                native-value="9"
              >非定期</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionDeliveryKindFlagGroupNull">定期/非定期を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionAll">全件検索となる為、検索条件を絞り込んでください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <section>
      <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column">
            <b-field horizontal label="検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="date"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="date" label="登録日" sortable centered>{{ props.row.date }}</b-table-column>
              <b-table-column field="staffName" label="登録者" sortable>{{ props.row.staffName}}</b-table-column>
              <b-table-column field="officeName" label="営業所" sortable>{{props.row.officeName}}</b-table-column>
              <b-table-column
                field="productCode"
                label="品目コード"
                sortable
                centered
              >{{ props.row.productCode }}</b-table-column>
              <b-table-column field="productName" label="品目名" sortable>{{ props.row.productName }}</b-table-column>
              <b-table-column field="count" label="数量" sortable centered>{{ props.row.count }}</b-table-column>
              <b-table-column
                field="derivaryDate"
                label="納入期日"
                sortable
                centered
              >{{ props.row.derivaryDate }}</b-table-column>
              <b-table-column
                field="patientName"
                label="患者名"
                sortable
                centered
              >{{ props.row.patientName }}</b-table-column>
              <b-table-column
                field="deliveryKindFlag"
                label="定期/非定期"
                sortable
                centered
              >{{ props.row.deliveryKindFlag | deliveryKindFlag }}</b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
var data = [];
export default {
  name: "AppDispoDeliveryHistorySearch",
  methods: {
    search: function(searchConditions) {
      // 定期/非定期の選択は必須
      if (this.searchConditions.deliveryKindFlagGroup.length == 0) {
        this.isSearchConditionDeliveryKindFlagGroupNull = true;
        return;
      } else {
        this.isSearchConditionDeliveryKindFlagGroupNull = false;
      }
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(searchConditions.officeCode) ||
        this.isLength(searchConditions.staffCode) ||
        this.isLength(searchConditions.staffName) ||
        this.isLength(searchConditions.productCode) ||
        this.isLength(searchConditions.productName) ||
        this.isLength(searchConditions.patientCode) ||
        this.isLength(searchConditions.patientName)
      ) {
        if (this.searchConditions.deliveryKindFlagGroup.length > 0) {
          console.log("検索条件あり");
          this.isSearchConditionNull = false;
          this.isSearchConditionAll = false;

          // 検索条件の整形
          if (this.startDate && !(typeof this.startDate == "string")) {
            this.searchConditions.startDate = this.formatMonth2(this.startDate);
          }
          if (this.endDate && !(typeof this.endDate == "string")) {
            this.searchConditions.endDate = this.formatMonth2(this.endDate);
          }
          for (var val in this.searchConditions.deliveryKindFlagGroup) {
            this.searchConditions.deliveryKindFlagGroup[val] = parseInt(
              this.searchConditions.deliveryKindFlagGroup[val]
            );
          }

          var excuteApi = this.getRegularDisposablesHistoryListPOST;
          var successCallBack = this.getDeliveryHistoryListSuccess;
          var errorCallBack = this.getDeliveryHistoryListError;
          //  Web API Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
          // getRegularDisposablesHistoryList
          // パラメータ：searchConditions
        } else {
          this.isSearchConditionAll = false;
          return;
        }
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
        this.isSearchConditionAll = false;
      }
    },
    getRegularDisposablesHistoryListPOST: function(client) {
      return client.apis.apiInspection.getRegularDisposablesHistoryListPOST({
        body: {
          startDate: this.searchConditions.startDate,
          endDate: this.searchConditions.endDate,
          officeCode: this.searchConditions.officeCode,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          deliveryKindFlagGroup: this.searchConditions.deliveryKindFlagGroup
        }
      });
    },
    getDeliveryHistoryListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      for (var val in this.searchConditions.deliveryKindFlagGroup) {
        this.searchConditions.deliveryKindFlagGroup[val] =
          this.searchConditions.deliveryKindFlagGroup[val] + "";
      }
    },
    getDeliveryHistoryListError: function(result) {
      this.showErrorMessage(result);
      for (var val in this.searchConditions.deliveryKindFlagGroup) {
        this.searchConditions.deliveryKindFlagGroup[val] =
          this.searchConditions.deliveryKindFlagGroup[val] + "";
      }
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var searchConditions = {
      startDate: "",
      endDate: "",
      officeCode: "",
      staffCode: "",
      staffName: "",
      productCode: "",
      productName: "",
      patientCode: "",
      patientName: "",
      deliveryKindFlagGroup: ["1"]
    };
    var startDate;
    var endDate;
    if (userInfo.roleId != 1 && userInfo.roleId != 2) {
      searchConditions.officeCode = userInfo.officeCode;
      searchConditions.staffCode = userInfo.staffCode;
      searchConditions.staffName = userInfo.fullName;
    }
    return {
      data,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 100,
      searchConditions,
      userInfo,
      isSearchConditionNull: false,
      isSearchConditionDeliveryKindFlagGroupNull: false,
      isSearchConditionAll: false,
      startDate,
      endDate
    };
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppDispoDeliveryHistorySearch.vue